import { useTranslation } from 'react-i18next';
import { ViewComponentProps } from '../../../common';
import { DocumentType } from '../../types';
import { SummaryViewTitle } from '../widgets';

type DocumentsViewProps = ViewComponentProps & {
  documents: DocumentType[];
  showEditIcon?: boolean;
};

const DocumentsView: React.FC<DocumentsViewProps> = ({ title, documents, hasTitle = true, showEditIcon = true }) => {
  const { t } = useTranslation();
  const viewTitle = hasTitle ? t(title || 'enrollments.documentsViewTitle') : '';

  return (
    <div className="schedule-form" data-testid="documents-view">
      <SummaryViewTitle title={viewTitle} showEditIcon={showEditIcon} />
      {documents.length === 0 && <div className="font-bold">{t('common.none')}</div>}
      <div className="documents">
        {documents.map((document) => (
          <div key={document.id} className="document">
            <div className="document-name">{document.name}</div>
          </div>
        ))}
      </div>
    </div>
  );
};
export default DocumentsView;
